module.exports = __webpack_public_path__ + "img/20_Antrum+GC.190debc5.png";